import React, { useState, useMemo, useCallback } from 'react';
import './UnreadMessages.css';
import Pagination from '../Pagination/Pagination';
import { BsGeoAltFill } from 'react-icons/bs';
import { CgAlarm, CgCalendar } from 'react-icons/cg';

const itemsPerPage = 3;

const UnreadMessages = React.memo(({ data = [] }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = useMemo(() => Math.ceil(data.length / itemsPerPage), [data]);
  const currentData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return data.slice(startIndex, startIndex + itemsPerPage);
  }, [data, currentPage]);

  const handlePageChange = useCallback(newPage => setCurrentPage(newPage), []);

  return (
    <div className="unread-card p-3 mb-4">
      <div className="messages-header">
        <h5 className="messages-title">Unread Messages</h5>
      </div>

      <div className="messages-list">
        {currentData.map((msg, idx) => (
          <div key={idx} className="message-card d-flex">

            {/* Avatar/Logo column */}
            <div className="avatar-col">
              <div className="avatar">{msg.sender.charAt(0).toUpperCase()}</div>
              <BsGeoAltFill className="location-icon" />
            </div>

            {/* Content column */}
            <div className="content-col flex-grow-1">
              <div className="line1 d-flex justify-content-between align-items-center">
                <span className="sender-name">{msg.sender}</span>
                <div className="unread-count-box">
                  {msg.unreadCount}
                  {msg.unreadCount > 0 && <span className="red-dot"></span>}
                </div>
              </div>

              <div className="line2 d-flex justify-content-between align-items-center">
                <span className="sender-address">{msg.address}</span>
                <div className="d-flex align-items-center">
                  <CgAlarm className="time-icon" />
                  <span className="message-time">{msg.time}</span>
                </div>
              </div>

              <div className="line3 d-flex justify-content-between align-items-center">
                <span className="message-status">{msg.status}</span>
                <div className="d-flex align-items-center">
                  <CgCalendar className="time-icon" />
                  <span className="message-date">{msg.date}</span>
                </div>
              </div>

            </div>
          </div>
        ))}

        {!currentData.length && (
          <div className="no-data">No unread messages</div>
        )}
      </div>

      {totalPages > 1 && (
        <div className="pagination-wrapper">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
});

export default UnreadMessages;
